import { el, noteWords } from './ui'
import { shownTime } from './round-config'

// A visit's note, one line per entry. The server stamps a voice note as
// "🎙 12:03 — text" and a running-late text as "⏱ 12:03 — told …"; those
// stamps stay in the stored note (History and exports read them), but on
// screen the emoji becomes the app's own drawn icon (Liam, 2026-09-23: "you're
// just using emojis, it doesn't look very professional").

const STAMPED = /^(🎙|⏱)\s+(\d{1,2}:\d{2})\s+—\s+(.*)$/u
const ICON_OF: Record<string, string> = { '🎙': 'ic-mic', '⏱': 'ic-clock' }

// Owed's "This visit wasn't done" used to store "Not done — marked from Owed 12 Sep"; it now stores a colon, and the old
// ones read the same on screen (Liam, 9 Oct 2026: no long dashes). The stored note is left as it was.
export function noteText(line: string): string {
  return noteWords(line.replace(/^Not done\s+[—–]\s+marked from Owed/i, 'Not done: marked from Owed'))
}

export function noteNode(note: string): HTMLElement {
  const box = el('span', { class: 'clean-note' })
  for (const raw of note.split('\n')) {
    const line = raw.trim()
    if (!line) continue
    const m = STAMPED.exec(line)
    if (m) {
      box.append(el('span', { class: `note-line note-stamped ic ${ICON_OF[m[1]]}` }, el('span', { class: 'note-clock' }, shownTime(m[2])), ` ${noteWords(m[3])}`))
    } else {
      box.append(el('span', { class: 'note-line' }, noteText(line)))
    }
  }
  return box
}
